import { API_URL } from "env";

interface OtherDataAPIResponse {
    status: boolean;
    data: {
        id: number;
        name: string;
        code: string;
        is_active: number;
        type: number;
        position: number;
        slug: string;
        short_content: string | null;
        content: string | null;
        json: string;
        avatar: string | null;
        list_thumbnail: unknown[];
        created_at: string;
        child: unknown[];
    };
    msg: string;
}

async function mixOther(code: string, lang: "vi" | "en") : Promise<OtherDataAPIResponse | null> {
    try {
        const response = await fetch(`${API_URL}/api/v1/fe/other/${code}?language=${lang}`);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data: OtherDataAPIResponse = await response.json();
        return data;
    } catch (error) {
        console.error("Error fetching other data:", error);
        return null;
    }
}

function jsonParseSafe(jsonString: string): unknown {
    try {
        return JSON.parse(jsonString);
    } catch (error) {
        console.error("Error parsing JSON:", error);
        return null;
    }
}

export { mixOther };